const mutinid = {
  state: {
  // 启停记录弹窗
    startStop: false,
    startStop1: false

  },
  mutations: {
  // 选择的用户名
    add_startStop (state, startStop) {
      state.startStop = startStop
      console.log(state.startStop, '开始了')
    },
    add_startStop1 (state, startStop1) {
      state.startStop1 = startStop1
      console.log(state.startStop1, '开始了')
    }
  },
  actions: {
  // 选择的用户名
    addstartStop ({ commit }, data) {
      commit('add_startStop', data)
    // console.log(data);
    },
    addstartStop1 ({ commit }, data) {
      commit('add_startStop1', data)
    // console.log(data);
    }
  },
  getters: {
    startStop: state => state.startStop,
    startStop1: state => state.startStop1
  // scrollHeight: state => state.scrollHeight,
  // nowscrollHeight: state => state.nowscrollHeight
  }
}
export default mutinid



// WEBPACK FOOTER //
// ./src/store/modules/mutinid.js